// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import iPicker from 'i-picker'
import "./rem"
/*引入资源请求插件*/
import VueResource from 'vue-resource'

/*使用VueResource插件*/
Vue.use(VueResource)
Vue.use(iPicker)
Vue.use(vant)
Vue.config.productionTip = false
import { GetUrlParam } from "./utils/GetUrlParam.js"
import i18n from './assets/i18n'
const language = GetUrlParam("language")
import { Locale } from 'vant';
// 引入语言包
import mongolian from './assets/lang/mongolian'
import enUS from 'vant/es/locale/lang/en-US'
import zh_CN from 'vant/es/locale/lang/zh-CN'
import vi from './assets/lang/vi-VN'


if (language != undefined) {
  localStorage.setItem('lang', language)
  let langs = language
  if(language == 'mongolian') {
     Locale.use('mongolian', mongolian)
    localStorage.setItem('lang', mongolian)
  } else if (language == 'zh-en' || language == 'en') {
    // 引入英文语言包
    Locale.use('en-US', enUS)
    langs = 'zh-en'
    localStorage.setItem('lang', 'zh-en')
  } else if (language == 'zh-cn' || language == 'zh') {
    // 引入中文语言包
    Locale.use('zh-CN', zh_CN)
    langs = 'zh-cn'
    localStorage.setItem('lang', 'zh-cn')
  } else if (language == 'vi') {
    // 引入越南语言包
    Locale.use('vi-VN', vi)
  }else if (language == 'ar') {
    localStorage.setItem('lang', 'ar')
  }

  i18n.locale = langs
  i18n.fallbackLocale = langs
}

import axios from 'axios'
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
// 在发送请求之前做些什么
  let params = config.params ? config.params : []
  params.language = language
  config.params = params
  console.log(config)
  return config
});

Vue.prototype.baseUrlApi = process.env.API_ROOT
Vue.prototype.baseUrlPath = process.env.URL_PATH

console.log(process.env.URL_PATH)
// vConsole控制台，开发环境有效，生产环境不显示
import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
if (process.env.NODE_ENV == "development") {
  let vConsole = new VConsole() // 初始化
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js